import { Inject, inject, Injectable } from '@angular/core';
import { HttpService } from '@docpath/linces-angular-components/common';
import { DpCustomHttpResponse, DpHttpEnvironment } from '@docpath/webcomponents';
import { Observable } from 'rxjs';

import { ServicesConfig } from '../models/services-config';



@Injectable({
    providedIn: 'root'
})
export class ServicesHttpService {
    private readonly httpService = inject(HttpService);

    private readonly relativeUrl: string;

    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(@Inject('environment') private readonly environment: DpHttpEnvironment) {
        this.relativeUrl = `${this.environment.accessControlApiPath}/services`;
    }

    getConfig(): Observable<ServicesConfig> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/config`,
                loading: true,
                suscribe: response => {
                    const config = response.result as unknown as ServicesConfig;

                    observer.next(config);
                    observer.complete();
                }
            });
        });
    }

    updateConfig(config: ServicesConfig): Observable<void> {
        return new Observable(observer => {
            this.httpService.put(config, {
                relativeUrl: `${this.relativeUrl}/config`,
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'services-config.aim.toast.success'
            });
        });
    }

    testAimConnection(url: string, token: string): Observable<DpCustomHttpResponse> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/aim/connection`,
                queryParameters: { url, token },
                suscribe: response => {
                    observer.next(response);
                    observer.complete();
                },
                suscribeOnError: () => {
                    observer.next({ result: false } as unknown as DpCustomHttpResponse);
                    observer.complete();
                }
            });
        });
    }

}
